import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { QueryClient, QueryClientProvider, Hydrate } from '@tanstack/react-query';
export var ReactQueryWrapper = function (_a) {
    var children = _a.children, dehydratedState = _a.dehydratedState;
    var queryClient = useState(function () { return new QueryClient(); })[0];
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(Hydrate, { state: dehydratedState, children: children }) }));
};
